import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import UserLayout from './components/UserLayout';
import Login from './components/Login';
import OAuthRedirect from './components/OAuthRedirect';
import Dashboard from './components/Dashboard';
import Recordings from './components/Recordings';
import Users from './components/Users';
import Analytics from './components/Analytics';
import Settings from './components/Settings';
import Profile from './components/Profile';
import UserDashboard from './components/UserDashboard';
import UserJobs from './components/UserJobs';
import UserAccount from './components/UserAccount';
import UserSettings from './components/UserSettings';
import UserProfile from './components/UserProfile';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancel from './components/PaymentCancel';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import PermissionRouter from './components/PermissionRouter';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <PermissionRouter>
            <Routes>
              <Route path="/loginPage" element={<Login />} />
              <Route path="/oauth2route/redirect" element={<OAuthRedirect />} />
              
              {/* Payment Routes */}
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              
              {/* Admin Portal Routes */}
              <Route
                path="/*"
                element={
                  <AdminRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/recordings" element={<Recordings />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/analytics" element={<Analytics />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/profile" element={<Profile />} />
                      </Routes>
                    </Layout>
                  </AdminRoute>
                }
              />
              
              {/* User Portal Routes */}
              <Route
                path="/user/*"
                element={
                  <ProtectedRoute>
                    <UserLayout>
                      <Routes>
                        <Route path="/" element={<UserDashboard />} />
                        <Route path="/jobs" element={<UserJobs />} />
                        <Route path="/account" element={<UserAccount />} />
                        <Route path="/settings" element={<UserSettings />} />
                        <Route path="/profile" element={<UserProfile />} />
                      </Routes>
                    </UserLayout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </PermissionRouter>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
